import React, { useState, useEffect } from 'react';
import landingPageAPI from '../../services/api';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './Testimonials.css';

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [title, setTitle] = useState('Trusted by Organizations of Every Size');
  const [subtitle, setSubtitle] = useState('See what our clients are saying');
  const [useCases] = useState([
    {
      id: 1,
      icon: '🏛️',
      title: 'Government Organizations',
      description: 'Manage staff across multiple cities.'
    },
    {
      id: 2,
      icon: '🎓',
      title: 'Schools & Universities',
      description: 'Student + teacher attendance tracking.'
    },
    {
      id: 3,
      icon: '🏢',
      title: 'Private Companies',
      description: 'Office + remote employee attendance.'
    },
    {
      id: 4,
      icon: '🏭',
      title: 'Retail & Factories',
      description: 'Shift-based workforce management.'
    }
  ]);

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const response = await landingPageAPI.getAllContent();
      if (response.data.status === 'success') {
        setTestimonials(response.data.data.testimonials || []);

        const sections = response.data.data.sections || [];
        const testimonialsSection = sections.find(s => s.section_key === 'testimonials');

        if (testimonialsSection && testimonialsSection.content) {
          const titleContent = testimonialsSection.content.find(c => c.content_key === 'testimonials_title');
          const subtitleContent = testimonialsSection.content.find(c => c.content_key === 'testimonials_subtitle');

          if (titleContent) setTitle(titleContent.content_value);
          if (subtitleContent) setSubtitle(subtitleContent.content_value);
        }
      }
    } catch (error) {
      console.error('Failed to fetch testimonials:', error);
    }
  };

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <span key={i} className={i <= rating ? 'star filled' : 'star'}>
          {i <= rating ? '★' : '☆'}
        </span>
      );
    }
    return stars;
  };

  return (
    <section className="testimonials" id="testimonials">
      <div className="container">
        {/* Use Cases */}
        <div className="use-cases-section">
          <div className="section-title">
            <h2>Perfect for Every Industry</h2>
          </div>
          <div className="use-cases-grid">
            {useCases.map((useCase) => (
              <div key={useCase.id} className="use-case-card">
                <div className="use-case-icon">{useCase.icon}</div>
                <h3>{useCase.title}</h3>
                <p>{useCase.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Testimonials & Reviews */}
        <div className="reviews-section">
          <div className="section-title">
            <h2>{title}</h2>
            <p>{subtitle}</p>
          </div>

          {testimonials.length > 0 ? (
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              slidesPerView={1}
              spaceBetween={30}
              loop={testimonials.length > 3}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
              }}
              pagination={{
                clickable: true,
                dynamicBullets: true
              }}
              navigation={true}
              breakpoints={{
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 30
                }
              }}
              className="testimonials-carousel"
            >
              {testimonials.map((testimonial) => (
                <SwiperSlide key={testimonial.id}>
                  <div className="testimonial-card">
                    <div className="rating">{renderStars(testimonial.rating || 5)}</div>
                    <p className="testimonial-text">"{testimonial.testimonial_text}"</p>
                    <div className="author-info">
                      <p className="testimonial-author">{testimonial.client_name}</p>
                      <p className="testimonial-position">
                        {testimonial.client_position}
                        {testimonial.client_company && `, ${testimonial.client_company}`}
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <div className="no-testimonials">
              <p>No testimonials available yet.</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
